// Chrome-109-safe stand-in for the ES2024 `Promise.withResolvers` builtin (Chrome 119+), which
// the browser floor (`packages/eslint-config/compat.cjs`) forbids.
export const deferred = <T = void>() => {
  let resolve!: (value: T | PromiseLike<T>) => void;
  let reject!: (reason?: unknown) => void;
  const promise = new Promise<T>((res, rej) => {
    resolve = res;
    reject = rej;
  });
  return { promise, resolve, reject };
};
